import { BaseIdentity } from './base-identity';
import { CoreModel } from './core-model';

export abstract class BaseRootModel<TIdentity extends BaseIdentity>
    extends CoreModel<TIdentity>  {

}
